import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/regulatory-affairs/regulatory-affairs-for-ivds")({
  head: () => buildRouteHead("/en/services/regulatory-affairs/regulatory-affairs-for-ivds", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/services/regulatory-affairs", replace: true });
  },
});
